module.exports = __webpack_public_path__ + "img/level-down-alt.25ceb8e0.svg";